export default __webpack_public_path__ + "static/media/close-popup.49ec80b2.svg";